import Typography from "@mui/material/Typography";
import Kbd from "../Kbd.tsx";

/** A review drawer's keys, under its actions. */
export default function ShortcutHints({
  canDecide,
  canStep = true,
}: {
  canDecide: boolean;
  canStep?: boolean;
}) {
  return (
    <Typography variant="caption" sx={{ color: "text.secondary" }}>
      {canDecide && (
        <>
          <Kbd>P</Kbd> pursue · <Kbd>S</Kbd> pursue & snooze · <Kbd>D</Kbd> disqualify
          {canStep && " · "}
        </>
      )}
      {canStep && (
        <>
          <Kbd>J</Kbd>
          <Kbd>↓</Kbd> next · <Kbd>K</Kbd>
          <Kbd>↑</Kbd> previous
        </>
      )}
    </Typography>
  );
}
